import { useMutation } from "@apollo/client";
import useLazyRecipeAndIngredientsGroceryList from "./useLazyRecipeAndIngredientsGroceryList";
import { changeIngredientsOnServing } from "../../app/recipePage/recipePage.slice";
import { useAppSelector } from "../../app/store/hooks";
import { groceryListIdSelector } from "../../app/groceryList/groceryList.slice";
import { useState } from "react";
import { INSERT_ITEMS_IN_SHOPPING_LIST } from "../../app/graphql/mutations";

const useUpdateGroceryListFromAddingMeal = () => {
  const [loading, setLoading] = useState(false);
  const groceryListId = useAppSelector(groceryListIdSelector)
  const { getRecipeAndIngredientsGroceryList } = useLazyRecipeAndIngredientsGroceryList()
  const [insertItems] = useMutation(INSERT_ITEMS_IN_SHOPPING_LIST);

  const updateGroceryListFromAddingMeal = async (addedMealReturnData: any[], shoppingListId?: string) => {
    setLoading(true);
    const mealRecipesData = await getRecipeAndIngredientsGroceryList(addedMealReturnData);
    if (!mealRecipesData) return null; // TODO: handle error
    const adjustedData = mealRecipesData.map(meal => {
      const IngredientBasedOnServingSize = changeIngredientsOnServing(meal.substeps, meal.servingSize);

      return IngredientBasedOnServingSize.map((ingredient: any) => ({
        ...meal,
        ingredient
      }))
    })

    const shoppingListData: any = [];
    adjustedData?.forEach((meal) => {
      meal.forEach((mealData) => {
        const shoppingListItem = {
          shopping_list_id: shoppingListId || groceryListId,
          meal_id: mealData.mealId,
          ingredient_id: mealData.ingredient.ingredientId,
          amount: mealData.ingredient.qty,
          unit: mealData.ingredient.unit,
          serving_size: mealData.servingSize
        }
        shoppingListData.push(shoppingListItem)
      })
    })
    try {
      const response = await insertItems({
        variables: { items: shoppingListData }
      });
    } catch (err) {
      console.error("Error inserting shopping list items:", err);
    }

    setLoading(false);
    return adjustedData
  }
  return {
    updatingGroceryListFromAddingMeal: loading,
    updateGroceryListFromAddingMeal
  };
}

export default useUpdateGroceryListFromAddingMeal